module.exports = __webpack_public_path__ + "img/mercy.7fe4ee97.png";